module.exports = __webpack_public_path__ + "static/media/clock_icon.8ede249e.svg";